import { RouteType } from '@/lib/route';
import ElearningReviewers from '@/pages/Module/Reviewers';

const ElearningReviewersRoutes: RouteType = {
  path: '/module/:elearningId/reviewers',
  component: ElearningReviewers,
};

export default ElearningReviewersRoutes;
